import { render, staticRenderFns } from "./WizardTabNew.vue?vue&type=template&id=34ed3b8c"
import script from "./WizardTabNew.vue?vue&type=script&lang=js"
export * from "./WizardTabNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports